export const PARAM_SORT = {
  LATEST: 'date,desc', // 최신 거래순
  OLDEST: 'date,asc', // 오래된 거래순
  COUNT_HIGH: 'count,desc', // 높은 잔여 수량순, 높은 보유 수량순
  COUNT_LOW: 'count,asc', // 낮은 잔여 수량순, 낮은 보유 수량순
  RELEASE_DATE_LATEST: 'releaseDate,desc', // 최신 작품순
  RELEASE_DATE_OLDEST: 'releaseDate,asc', // 오래된 작품순
  UNTIL_DATE_LATEST: 'untilDate,asc', // 종료 날짜 빠른순
  UNTIL_DATE_OLDEST: 'untilDate,desc', // 종료 날짜 느린순
  REVENUE_RATE_HIGH: 'revenueRate,desc', // 수익률 높은순
  REVENUE_RATE_LOW: 'revenueRate,asc', // 수익률 낮은순
  DESC: 'createdDate,desc', // FIXME : 확인 후 sort 코드 통일 필요
  ASC: 'createdDate,asc', // FIXME : 확인 후 sort 코드 통일 필요
  // point
  ALL: 'ALL',
  SAVE: 'SAVE',
  CHANGE: 'CHANGE',
  EXTINCTION: 'EXTINCTION',
  // TODO: 금액 높은순/금액 낮은순
} as const

export const PARAM_SORT_KEYS = Object.keys(PARAM_SORT).reduce((accumulator, value) => {
  return { ...accumulator, [value]: value }
}, {}) as { [key in PARAM_SORT_TYPE]: PARAM_SORT_TYPE }

export type PARAM_SORT_TYPE = keyof typeof PARAM_SORT

export enum PARAM_FILTER {
  ALL = 'ALL',
  ALL_LOW = 'all',
  SALE = 'SALE',
  SALE_LOW = 'sale',
  BUY = 'BUY',
  TRADE_BUY = 'trade.buy',
  SELL = 'SELL',
  TRADE_SELL = 'trade.sell',
  TRANSFER = 'walletTransfer',
  DESTRUCT = 'destruct',
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  REVENUE = 'REVENUE',
  REFUND = 'REFUND',
  REFUND_LOW = 'refund',
  FAVORITE = 'FAVORITE',
  MINE = 'MINE',
  DONE = 'DONE', // FIXME : PARAM이 아닌 탭을 선택하기 위한 타입
  YET = 'YET', // FIXME : PARAM이 아닌 탭을 선택하기 위한 타입
  // TODO: 청약 환불 확인 필요
  CANCEL = 'CANCEL',
  SETTLEMENT = 'SETTLEMENT', // 매각 대금
  UNALLOCATED = 'UNALLOCATED', // 배정 환물
}

// TODO: 수정 필요
export type CATEGORY_LIST = {
  id: number | undefined
  title?: string
  name?: string
  description?: string
  sortIndex?: number
}[]

export const DisclosureCategory = {
  0: '전체',
  1: '정기공시',
  2: '수시공시',
  3: '자율공시',
  4: '조회공시',
  5: '기타공시',
} as const
